import { render, staticRenderFns } from "./pfqd.vue?vue&type=template&id=4e869334&scoped=true&"
import script from "./pfqd.vue?vue&type=script&lang=js&"
export * from "./pfqd.vue?vue&type=script&lang=js&"
import style0 from "./pfqd.vue?vue&type=style&index=0&id=4e869334&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e869334",
  null
  
)

export default component.exports